import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import IntroSection from './components/IntroSection';
import DesignSection from './components/DesignSection';
import FeaturesSection from './components/FeaturesSection';
import MoreThanCuteSection from './components/MoreThanCuteSection';
import TweetSection from './components/TweetSection';
import VoiceSection from './components/VoiceSection';
import EmotionSection from './components/EmotionSection';
import AloneSection from './components/AloneSection';
import PlaySection from './components/PlaySection';
import ProtectSection from './components/ProtectSection';
import TalkSection from './components/TalkSection';
import EmotionsPageSection from './components/EmotionsPageSection';
import FusionSkinSection from './components/FusionSkinSection';
import FusionGallerySection from './components/FusionGallerySection';
import AppControlSection from './components/AppControlSection';
import RobotSpecsSection from './components/RobotSpecsSection';
import QuestionsSection from './components/QuestionsSection';
import ReservationSection from './components/ReservationSection';
import FooterSection from './components/FooterSection';
import LanguageSwitcher from './components/LanguageSwitcher';
import CombinedVoiceTweetSection from './components/CombinedVoiceTweetSection';

// 在这个列表中添加所有需要使用i18n的组件
const I18nSupportedComponents = [
  'Header', 'Hero', 'IntroSection', 'DesignSection', 'FeaturesSection',
  'MoreThanCuteSection', 'TweetSection', 'VoiceSection', 'EmotionSection',
  'AloneSection', 'PlaySection', 'ProtectSection', 'TalkSection',
  'EmotionsPageSection', 'FusionSkinSection', 'FusionGallerySection',
  'AppControlSection', 'RobotSpecsSection', 'QuestionsSection',
  'ReservationSection', 'FooterSection', 'CombinedVoiceTweetSection'
];

function App() {
  // 添加移动端检测状态
  const [isMobile, setIsMobile] = useState(false);
  // 是否是大屏幕（用于显示组合组件）
  const [isLargeScreen, setIsLargeScreen] = useState(false);

  // 检测屏幕尺寸并更新isMobile和isLargeScreen状态
  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      // 768px是常用的移动设备断点，可以根据需要调整
      setIsMobile(width <= 768);
      // 992px以上为大屏幕，显示组合组件
      setIsLargeScreen(width > 992);
    };

    // 初始检测
    checkScreenSize();

    // 添加窗口大小变化监听器
    window.addEventListener('resize', checkScreenSize);

    // 清理监听器
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // 提示开发者在各个组件中添加i18n支持
  useEffect(() => {
    console.log('请确保以下组件已添加i18n支持:', I18nSupportedComponents);
  }, []);

  // TODO: 开发更多移动端适配策略，如字体大小调整、布局优化等

  return (
    <div className={`App ${isMobile ? 'mobile-view' : ''}`}>
      <LanguageSwitcher />
      <Header isMobile={isMobile} />
      {isMobile && <IntroSection isMobile={isMobile} isFirstPage={true} />}
      <Hero isMobile={isMobile} />
      {!isMobile && <IntroSection isMobile={isMobile} isFirstPage={false} />}
      <DesignSection isMobile={isMobile} />
      <TalkSection isMobile={isMobile} />
      <AloneSection isMobile={isMobile} />
      <PlaySection isMobile={isMobile} />
      <ProtectSection isMobile={isMobile} />
      <FeaturesSection isMobile={isMobile} />
      <MoreThanCuteSection isMobile={isMobile} />
      <EmotionsPageSection isMobile={isMobile} />
      <EmotionSection isMobile={isMobile} />
      
      {/* 大屏幕显示组合组件，小屏幕显示原始组件 */}
      {isLargeScreen ? (
        <CombinedVoiceTweetSection />
      ) : (
        <>
          <TweetSection isMobile={isMobile} />
          <VoiceSection isMobile={isMobile} />
        </>
      )}
      
      <FusionSkinSection isMobile={isMobile} />
      <FusionGallerySection isMobile={isMobile} />
      <AppControlSection />
      <RobotSpecsSection isMobile={isMobile} />
      <QuestionsSection isMobile={isMobile} />
      <ReservationSection isMobile={isMobile} />
      <FooterSection isMobile={isMobile} />
    </div>
  );
}

export default App;
